import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useForm } from "react-hook-form"
import shopCore from "../../core/shop.core"
import { SalesLocation } from "../../types/shop"
import { useGetSalesLocation } from "./useGetSales.hook"
import { useEffect } from "react"
import { useRouter } from "next/router"

export default function useDeleteSalesLocation() {
  const queryClient = useQueryClient()
  const methods = useForm<SalesLocation>()

  const formhandler = useMutation({
    mutationFn: async (id) => {
      await shopCore.deleteSalesLocation(id)
    }, onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sales-location"] })
    }
  })

  const onSubmit = async (id) => {
    await formhandler.mutateAsync(id)
  }
  return {
    methods,
    onSubmit,
    formhandler,
  }
}
